import type * as React from 'react';
import { StyleSheet } from 'react-native';

import type { InlineProps } from '@gitbook/slate-react';

import { DOMText } from '../../DragAndDrop';
import { Interactive } from '../../Interactive';
import { themedFonts, useCurrentTheme } from '../../theme';

/*
 * Basic renderer for an inline link
 */
export function BasicInlineLink(props: InlineProps): React.ReactElement {
    const { node, children, attributes } = props;

    const [, font] = useCurrentTheme(themedFonts);

    const linkRef = node.data.get('ref');

    return (
        <DOMText tag="a" {...{ href: linkRef.url }}>
            <Interactive.TouchableOpacity {...props} style={[styles.wrapper]}>
                <Interactive.Text.Child
                    {...attributes}
                    hoverStyle={[font.primaryStandout, font.Underline]}
                    inactiveStyle={font.primary}
                >
                    {children}
                </Interactive.Text.Child>
            </Interactive.TouchableOpacity>
        </DOMText>
    );
}

const styles = StyleSheet.create({
    wrapper: {
        // @ts-ignore RN doesn't support display: inline
        display: 'inline',
    },
});
